import { workspaceSetupModule } from './modules/workspace-setup';
import { digitalCollaborationModule } from './modules/digital-collaboration';
import { workLifeBalanceModule } from './modules/work-life-balance';
import { virtualTeamLeadershipModule } from './modules/virtual-team-leadership';

export const REMOTE_WORK_EXCELLENCE_COURSES = [
  {
    id: 'remote-work-excellence',
    title: 'Remote Work Excellence & Digital Collaboration',
    description: 'Master remote work productivity, digital collaboration, and virtual team leadership.',
    level: 'intermediate',
    totalDuration: '3 hours',
    image: '/api/placeholder/400/300',
    prerequisites: ['Basic technology skills'],
    learningOutcomes: [
      'Optimize remote work setup and productivity systems',
      'Master digital collaboration tools and best practices',
      'Maintain work-life balance in remote environments',
      'Lead and participate in effective virtual teams'
    ],
    modules: [
      workspaceSetupModule,
      digitalCollaborationModule,
      workLifeBalanceModule,
      virtualTeamLeadershipModule
    ]
  }
];